import React from "react";

const Input = (props) => {
  return (
    <input {...props} type={props.type || "text"} className={props.className} />
  );
};

export default Input;
